import React, { forwardRef, useState, useImperativeHandle, useRef } from "react";
import { Box, Stack, Typography, IconButton, Divider } from "@mui/material";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { Input } from "../Input";

const Occupants = forwardRef((props, ref) => {
    const [occupants, setOccupants] = useState(
        props.values ? props.values : [{ firstName: "", lastName: "", dob: null }]
    );

    const firstNameRef = useRef();
    const lastNameRef = useRef();
    const dobRef = useRef();
    const refs = [firstNameRef, lastNameRef, dobRef];

    useImperativeHandle(ref, () => ({
        validate,
    }));

    const validate = () => {
        let valid = false;
        for (let i = 0; i < refs.length; i++) {
            if (!refs[i].current.validate()) {
                valid = true;
            }
        }
        return !valid;
    };

    const handleAddClick = () => {
        let occupantsRecords = [...occupants, { firstName: "", lastName: "", dob: null }];
        setOccupants(occupantsRecords);
    };

    const handleRemoveClick = (index) => {
        let occupantsRecords = [...occupants];
        if (occupantsRecords.length > 1) {
            occupantsRecords.splice(index, 1);
            setOccupants(occupantsRecords);
            props.onChange(occupantsRecords);
        }
    };

    const handleChange = (index, field, value) => {
        let occupantsRecords = [...occupants];
        occupantsRecords[index][field] = value;
        setOccupants(occupantsRecords);

        props.onChange(occupantsRecords);
    };
    return (
        <Box>
            {occupants.map((item, index) => (
                <Box
                    sx={{
                        p: 1,
                        borderRadius: "8px",
                        border: "1px solid #E6E8F0",
                        overflow: "visible",
                        background: "#f8fdff",
                        width: "100%",
                        mb: 2,
                    }}
                >
                    <Grid container spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                        <Grid item>
                            <Typography gutterBottom variant="h5">
                                <b>Child {index === 0 ? index + 1 : index + 1}</b>
                            </Typography>
                        </Grid>
                        {(index > 1 || occupants.length > 1) && (
                            <Grid item>
                                <IconButton aria-label="delete" size="small" style={{ float: "right" }}>
                                    <DeleteOutlinedIcon
                                        color="error"
                                        fontSize="small"
                                        onClick={() => handleRemoveClick(index)}
                                    />
                                </IconButton>
                            </Grid>
                        )}
                    </Grid>

                    <Divider sx={{ mt: 1, mb: 1 }} />

                    <Input
                        ref={firstNameRef}
                        id="firstName"
                        type="text"
                        value={item.firstName}
                        margin="normal"
                        label="First Name"
                        onChange={(value) => handleChange(index, "firstName", value)}
                        isRequired={true}
                    ></Input>

                    <Input
                        ref={lastNameRef}
                        id="lastName"
                        type="text"
                        label="Last Name"
                        value={item.lastName}
                        margin="normal"
                        onChange={(value) => handleChange(index, "lastName", value)}
                        isRequired={true}
                    ></Input>

                    <Input
                        ref={dobRef}
                        id="dob"
                        type="date"
                        label="Date of Birth"
                        value={item.dob}
                        margin="normal"
                        onChange={(value) => handleChange(index, "dob", value)}
                        isRequired={true}
                        mask="99 / 99 / 9999"
                        placeholder="MM / DD / YYYY"
                    ></Input>
                </Box>
            ))}
            <Stack direction="row" spacing={2} sx={{ mt: 1, mb: 1 }} onClick={handleAddClick}>
                <AddCircleOutlineOutlinedIcon color="primary" />
                <Typography
                    variant="h6"
                    display="block"
                    gutterBottom
                    sx={{
                        textTransform: "none",
                        display: "flex",
                        alignItems: "center",
                        color: "#06aed4",
                        '&:hover': {
                            cursor: 'pointer'
                        }
                    }}
                >
                    <b>Add another occupant</b>
                </Typography>
            </Stack>
        </Box>
    );
});

export { Occupants };
